import { useParams } from "react-router-dom";

import { HeaderTitle } from "../../../../components/HeaderTitle";
import { useTranslate } from "../../../../hooks/useTranslate";
import { Container, ContentArtical } from "./styles";
import { M1, M2, M3, M4, M5, M6, M7 } from "../../../../components/Matters";

type Matter = Record<string, JSX.Element>;

const ViewArtical = () => {
  const params = useParams();
  const { translate } = useTranslate();

  if (!params?.id) return <></>;

  const matters: Matter = {
    "1": <M1 />,
    "2": <M2 />,
    "3": <M3 />,
    "4": <M4 />,
    "5": <M5 />,
    "6": <M6 />,
    "7": <M7 />,
  };

  return (
    <Container>
      <HeaderTitle
        title={translate("content_center.title_view")}
        showIcon
        url="/content-center"
      />
      <ContentArtical>{matters[params.id!]}</ContentArtical>
    </Container>
  );
};

export { ViewArtical };
